import { SyncOutlined } from '@ant-design/icons';
import { App, Button } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'translations/hooks';

import { useServiceWorkerUpdate } from './useServiceWorkerUpdate';

const KEY = 'pwa-update-notification';

export const UpdateNotification = () => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const { showUpdatePrompt, applyUpdate, dismissUpdate } =
    useServiceWorkerUpdate();

  useEffect(() => {
    if (showUpdatePrompt) {
      notification.open({
        key: KEY,
        message: t('pwa.updateAvailable.title'),
        description: t('pwa.updateAvailable.description'),
        icon: <SyncOutlined style={{ color: '#012169' }} />,
        duration: undefined,
        placement: 'bottomRight',
        btn: (
          <Button
            type="primary"
            size="small"
            onClick={() => {
              notification.destroy(KEY);
              applyUpdate();
            }}
          >
            {t('pwa.updateAvailable.action')}
          </Button>
        ),
        onClose: dismissUpdate,
      });
    } else {
      notification.destroy(KEY);
    }
  }, [showUpdatePrompt, notification, t, applyUpdate, dismissUpdate]);

  return null;
};
